import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { lightTheme as theme } from '../../theme';

const LoadingContainer = styled.div`
    background: ${theme.colors.paper};
    border-radius: 12px;
    box-shadow: ${theme.colors.shadowSm};
    border: 1px solid ${theme.colors.gray200};
    padding: 48px;
    text-align: center;
    color: ${theme.colors.textSecondary};
    font-size: 15px;
`;

const ErrorContainer = styled.div`
    background: ${theme.colors.dangerBg};
    color: ${theme.colors.danger};
    border-radius: 12px;
    border: 1px solid ${theme.colors.danger};
    padding: 20px;
    font-size: 14px;
`;

const FeedbackState = ({ loading, error, loadingMessage, errorMessage }) => {
    if (loading) {
        return <LoadingContainer>{loadingMessage}</LoadingContainer>;
    }

    if (error) {
        return <ErrorContainer>{errorMessage || error}</ErrorContainer>;
    }

    return null;
};

FeedbackState.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    loadingMessage: PropTypes.string,
    errorMessage: PropTypes.string,
};

FeedbackState.defaultProps = {
    loading: false,
    error: '',
    loadingMessage: 'Carregando...',
    errorMessage: '',
};

export default FeedbackState;

